import VuexPersistence from 'vuex-persist'

export default {
    vuexLocal: new VuexPersistence({
        storage: window.sessionStorage,
        reducer: (state) => ({
            query: state.query
        })
    })
}

